import {register} from 'register-service-worker';

let refreshing = false;
let activeRegistration = null;

const checkForUpdates = (registration) => {
	if (registration && registration.update) {
		registration.update();
	}
}

const reloadWhenNewWorkerControlsPage = () => {
	if (!navigator.serviceWorker) {
		return;
	}

	navigator.serviceWorker.addEventListener('controllerchange', () => {
		if (refreshing) return;
		refreshing = true;
		window.location.reload();
	});
};

const activateWaitingWorker = (registration) => {
	if (!registration?.waiting) {
		return;
	}

	registration.waiting.postMessage({ type: 'SKIP_WAITING' });
};

const watchInstallingWorker = (registration) => {
	const installingWorker = registration?.installing;
	if (!installingWorker) {
		return;
	}

	installingWorker.addEventListener('statechange', () => {
		if (installingWorker.state === 'installed' && navigator.serviceWorker?.controller) {
			activateWaitingWorker(registration);
		}
	});
};

if (process.env.NODE_ENV === 'production') {
	reloadWhenNewWorkerControlsPage();

	window.addEventListener('focus', () => checkForUpdates(activeRegistration));
	document.addEventListener('visibilitychange', () => {
		if (document.visibilityState === 'visible') {
			checkForUpdates(activeRegistration);
		}
	});

    register(`${process.env.BASE_URL}service-worker.js`, {
        ready(registration) {
			activeRegistration = registration;
            checkForUpdates(registration);
            // Start checking for updates every 5 minutes
            setInterval(() => checkForUpdates(registration), 5 * 60 * 1000); // 5 minutes
        },
        registered(registration) {
			activeRegistration = registration;
			registration?.addEventListener?.('updatefound', () => watchInstallingWorker(registration));
            checkForUpdates(registration);
        },
        cached() {},
        updatefound(registration) {
			watchInstallingWorker(registration);
		},
        updated(registration) {
			activeRegistration = registration;
            activateWaitingWorker(registration);
        },
        offline() {},
        error(error) {
            console.error('Error during service worker registration:', error);
        },
    })
}
